import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=39803108&scoped=true"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"
import style0 from "./Date.vue?vue&type=style&index=0&id=39803108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39803108",
  null
  
)

export default component.exports